import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticleGuidePage from "@/pages/article/page";
import ArticleReviewPage from "@/pages/article/review/page";
import ArticleVsExcelPage from "@/pages/article/vs-excel/page";
import ArticleTemplatesPage from "@/pages/article/templates/page";
import ArticleBusinessPage from "@/pages/article/for-business/page";
import ArticleSecurityPage from "@/pages/article/security/page";
import ArticleFeaturesPage from "@/pages/article/features/page";
import ArticleTipsPage from "@/pages/article/tips/page";
import ArticleBenefitsPage from "@/pages/article/benefits/page";
import ArticleShoppingGuidePage from "@/pages/article/shopping-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/vigorbuy-spreadsheet-guide",
    element: <ArticleGuidePage />,
  },
  {
    path: "/vigorbuy-spreadsheet-review",
    element: <ArticleReviewPage />,
  },
  {
    path: "/vigorbuy-spreadsheet-vs-excel",
    element: <ArticleVsExcelPage />,
  },
  {
    path: "/vigorbuy-spreadsheet-templates",
    element: <ArticleTemplatesPage />,
  },
  {
    path: "/vigorbuy-spreadsheet-for-business",
    element: <ArticleBusinessPage />,
  },
  {
    path: "/vigorbuy-spreadsheet-security",
    element: <ArticleSecurityPage />,
  },
  {
    path: "/vigorbuy-spreadsheet-features",
    element: <ArticleFeaturesPage />,
  },
  {
    path: "/vigorbuy-spreadsheet-tips",
    element: <ArticleTipsPage />,
  },
  {
    path: "/vigorbuy-spreadsheet-benefits",
    element: <ArticleBenefitsPage />,
  },
  {
    path: "/vigorbuy-spreadsheet-shopping-guide",
    element: <ArticleShoppingGuidePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;